/** URL `?tab=` values for user overview. */
export const UserOverviewTabParam = {
  OVERVIEW: "overview",
} as const;

const PARAM_TO_TAB_ID: Record<string, string> = {
  [UserOverviewTabParam.OVERVIEW]: "1",
};

export function userOverviewTabIdFromSearchParam(tab: string | null): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function isValidUserOverviewTabParam(tab: string | null): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
